module.exports = __webpack_public_path__ + "assets/img/index-logo.f153f565.png";